import React, { useState } from 'react';
import './Header.css';

const Header = ({ isScrolled, scrollToSection, openGallery }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo" onClick={() => handleNavClick('home')}>
            <img
              src="/total-logo.png"
              alt="Totalguard Workwear Rosslyn logo"
              className="logo-image"
            />
            <span className="logo-text">Totalguard Workwear Rosslyn</span>
          </div>

          {/* Navigation */}
          <nav className="nav">
            <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>
              Home
            </a>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>
              About
            </a>
            <a href="#products" onClick={(e) => { e.preventDefault(); handleNavClick('products'); }}>
              Products
            </a>
            <a href="#gallery" onClick={(e) => { e.preventDefault(); openGallery(); setIsMobileMenuOpen(false); }}>
              Gallery
            </a>
            <a href="#blog" onClick={(e) => { e.preventDefault(); handleNavClick('blog'); }}>
              Blog
            </a>
            <a href="#why-choose-us" onClick={(e) => { e.preventDefault(); handleNavClick('why-choose-us'); }}>
              Why Choose Us
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>
              Contact
            </a>
          </nav>

          {/* Mobile menu toggle */}
          <div className="mobile-menu" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="nav-mobile">
            <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>
              Home
            </a>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>
              About
            </a>
            <a href="#products" onClick={(e) => { e.preventDefault(); handleNavClick('products'); }}>
              Products
            </a>
            <a href="#gallery" onClick={(e) => { e.preventDefault(); openGallery(); setIsMobileMenuOpen(false); }}>
              Gallery
            </a>
            <a href="#blog" onClick={(e) => { e.preventDefault(); handleNavClick('blog'); }}>
              Blog
            </a>
            <a href="#why-choose-us" onClick={(e) => { e.preventDefault(); handleNavClick('why-choose-us'); }}>
              Why Choose Us
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>
              Contact
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
